export default __webpack_public_path__ + "static/media/workflowIcon.044d1952.svg";